import { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { clearVendorDraft } from "../../redux/actions/vendorRegistrationActions";
import { clearKycFile } from "../../redux/reducers/vendorKycReducer";

export default function RouteChangeListener() {
  const location = useLocation();
  const dispatch = useDispatch();
  const prevPathRef = useRef(location.pathname);

  useEffect(() => {
    const prev = prevPathRef.current;
    const curr = location.pathname;

    // If nothing actually changed, do nothing
    if (prev === curr) return;

    // --- VENDOR REGISTRATION logic ---
    // Case A: /vendor-registration → /vendor-kyc → keep draft
    if (prev === '/vendor-registration' && curr === '/vendor-kyc') {
      // do nothing
    }
    // Case B: /vendor-kyc → /vendor-registration → keep draft
    else if (prev === '/vendor-kyc' && curr === '/vendor-registration') {
      // do nothing
    }
    // Case C: /vendor-registration → any other route (not /vendor-kyc) → clear
    else if (prev === '/vendor-registration' && curr !== '/vendor-kyc') {
      dispatch(clearVendorDraft());
    }
    // Case D: arriving at /vendor-registration from any route except /vendor-kyc → clear
    else if (curr === '/vendor-registration' && prev !== '/vendor-kyc') {
      dispatch(clearVendorDraft());
    }

    // --- VENDOR KYC logic ---
    // Case A: /vendor-kyc → /vendor-registration → keep file
    if (prev === '/vendor-kyc' && curr === '/vendor-registration') {
      // do nothing
    }
    // Case B: /vendor-registration → /vendor-kyc → keep file
    else if (prev === '/vendor-registration' && curr === '/vendor-kyc') {
      // do nothing
    }
    // Case C: /vendor-kyc → any other route (not /vendor-registration) → clear
    else if (prev === '/vendor-kyc' && curr !== '/vendor-registration') {
      dispatch(clearKycFile());
    }
    // Case D: arriving at /vendor-kyc from any route except /vendor-registration → clear
    else if (curr === '/vendor-kyc' && prev !== '/vendor-registration') {
      dispatch(clearKycFile());
    }

    prevPathRef.current = curr;
  }, [location, dispatch]);

  return null;
}